import React from 'react';
import FileList from './FileList';
import WrapComponent from '../WrapComponent';
import './FileAttachment.less';

class FileIndex extends React.Component{
    render(){
        let props = this.props;
        const {getFieldProps} = props.form;
        let fieldProps = getFieldProps(props.api_name, {
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: props.is_required,
                    message: $st(`该项是必填项`)
                }]
            }]
        })

        return (
            <div>
                <FileList {...props} {...fieldProps}></FileList>
                {props.errorText&&<div className="input-error">{props.errorText}</div>}
            </div>
        )
    }
    
}

export default WrapComponent(FileIndex);


// WEBPACK FOOTER //
// ./src/component/FileAttachment/index.js